// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"987d35fd","89":"1ec3d9b1","227":"a7a0d9ad","273":"7ff87aa7","295":"0fad59d7","528":"99d8cee8","548":"94925fae","655":"47b0892e","738":"d17e2b89","956":"f9ab3c1f"}[chunkId] + ".chunk.js";
};